import React from 'react';
import PlateCard from './PlateCard';
import SelectablePlateCard from './SelectablePlateCard';
import { MonitoringRange, Plate } from '../Types';
import { PlateRegistrationSummary } from '../types/plateRegistration.types';

interface Props {
  plates: Array<Plate & { monitoringRange: MonitoringRange }>;
  selectingMultiple: boolean;
  selectedPlateNumbers: string[];
  togglePlateNumberSelect: (_: string) => void;
  showArchived: boolean;
  clientId?: string;
  registrationByPlateId?: Record<string, PlateRegistrationSummary>;
}

function PlatesGroup({
  plates,
  showArchived,
  selectingMultiple,
  selectedPlateNumbers,
  togglePlateNumberSelect,
  clientId,
  registrationByPlateId
}: Props) {
  const filteredPlates = showArchived ? plates : plates.filter((plate) => !plate.archivedAt);

  return (
    <div className="d-flex flex-wrap gap-3 p-2">
      {filteredPlates.map((plate) =>
        selectingMultiple ? (
          <SelectablePlateCard
            key={plate.id}
            plate={plate}
            selectedPlateNumbers={selectedPlateNumbers}
            togglePlateNumberSelect={togglePlateNumberSelect}
          />
        ) : (
          <PlateCard
            key={plate.id}
            plate={plate}
            clientId={clientId}
            registration={registrationByPlateId?.[plate.id]}
          />
        )
      )}
    </div>
  );
}

export default PlatesGroup;
